export interface Topic {
  id: string;
  name: string;
  subtitle: string;
  tag: string;
  cover: string;
}

export const topics: Topic[] = [
  {
    id: "oscar",
    name: "欧美奥斯卡作品精选",
    subtitle: "历届奥斯卡高光时刻，一次看懂学院派审美",
    tag: "奥斯卡",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20golden%20trophy%20statue%20on%20a%20dark%20velvet%20stage%20with%20warm%20spotlight%20and%20bokeh%20flashes%2C%20luxurious%20ceremony%20atmosphere%2C%20deep%20blue%20background%2C%20premium%20cinematic%20still&width=800&height=500&seq=topic-01&orientation=landscape",
  },
  {
    id: "classic-series",
    name: "经典剧集盘点",
    subtitle: "值得反复回味的欧美长剧，陪伴一代人的记忆",
    tag: "经典",
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20vintage%20film%20reels%20and%20old%20television%20sets%20in%20a%20warm%20retro%20living%20room%2C%20amber%20lighting%2C%20nostalgic%20memory%20mood%2C%20cinematic%20still&width=800&height=500&seq=topic-02&orientation=landscape",
  },
  {
    id: "top-rated",
    name: "高分必看榜",
    subtitle: "评分口碑双高的欧美影视，闭眼入不踩雷",
    tag: "高分",
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20row%20of%20glowing%20five%20star%20ratings%20above%20a%20dark%20cinema%20auditorium%2C%20warm%20amber%20accents%20on%20deep%20blue%2C%20premium%20review%20concept%20art&width=800&height=500&seq=topic-03&orientation=landscape",
  },
  {
    id: "new-release",
    name: "新片速递",
    subtitle: "近期上架的欧美新作，追更党的第一现场",
    tag: "新片",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20cinema%20marquee%20with%20glowing%20neon%20lights%20at%20night%2C%20fresh%20new%20release%20concept%2C%20warm%20amber%20and%20deep%20blue%20contrast%2C%20urban%20cinematic%20still&width=800&height=500&seq=topic-04&orientation=landscape",
  },
];